import React from 'react';
import './About.css'; // Importa o CSS específico para o About
import aboutImage from '../assets/undraw_developer_activity_re_39tg.svg'; // Adicione sua imagem em /assets

function About() {
  return (
    <section id="about" className="about-section">
      <div className="about-content">
        <div className="about-left">
          <h2>Sobre Nós</h2>
          <p>
            Somos um estúdio independente de desenvolvimento de jogos digitais e experiências interativas. Atuamos com criação própria de jogos para o público final e também com soluções personalizadas para empresas que buscam gamificar processos, promover marcas ou criar produtos digitais envolventes.
          </p>
          <p>
            Nosso trabalho combina jogabilidade sólida, desempenho otimizado e uma identidade visual bem definida. Temos experiência com diferentes estilos e plataformas, e buscamos sempre entregar projetos bem estruturados, acessíveis e prontos para o mercado.
          </p>
          <p>
            <h3>Missão</h3>
            Desenvolver jogos e experiências interativas de qualidade, com foco na diversão, na criatividade e na entrega de valor real tanto para jogadores quanto para parceiros.
          </p>
          <p>
            <h3>Visão</h3>
            Ser reconhecidos como um estúdio versátil, com um portfólio autoral sólido e projetos personalizados que geram impacto, seja no entretenimento ou nos negócios.
          </p>
          <p>
            <h3>Valores</h3>
            Comprometimento com a qualidade, respeito ao jogador e ao cliente, clareza na comunicação, criatividade aplicada e melhoria contínua em todas as etapas do desenvolvimento.
          </p>
          <p>
            Seja para criar um jogo completo, uma solução gamificada ou um projeto sob medida, trabalhamos para entregar resultados que engajem e façam a diferença.
          </p>
        </div>
        <div className="about-right">
          <img src={aboutImage} alt="Imagem ilustrativa sobre o estúdio" className="about-image" />
        </div>
      </div>
    </section>
  );
}

export default About;
